export const attributeType = [
  {
    key: 'text',
    value: 1
  },
  {
    key: 'number',
    value: 2
  },
  {
    key: 'color',
    value: 3
  }
];
